import { useMemo } from 'react';

import type { AgnosticCondition } from './internalTypings';

export const useDynamicEnabled = <T>({
    args,
    fetchOnMount = true,
    condition,
}: {
    args?: T;
    fetchOnMount?: boolean;
    condition?: AgnosticCondition<T>;
}) => {
    return useMemo(() => {
        if (condition && !condition(args as T)) {
            return false;
        }
        return fetchOnMount;
    }, [JSON.stringify(args), condition, fetchOnMount]);
};
